<div class="grid">
  <div class="col-12 messenger-container">
    <!-- Connected: page info + toggle -->
    <div class="estado-top-row" *ngIf="isConnected" data-testid="messenger-connected-state">
      <div class="estado-account-card">
        <div class="fb-avatar"><i class="pi pi-facebook"></i></div>
        <div class="estado-account-card__info">
          <span class="estado-account-card__name">{{ pageSubscription[0]?.page_name }}</span>
        </div>
      </div>

      <div class="estado-dm-card">
        <div class="estado-dm-card__top">
          <div>
            <span class="estado-dm-card__title">Activar asistente virtual en este canal</span>
            <span class="estado-dm-card__desc"
              >Tu asistente virtual responde automáticamente los mensajes que recibe esta página de
              Messenger.</span
            >
          </div>
          <p-inputSwitch
            [disabled]="false"
            [ngModel]="botEnabled"
            (onChange)="switchChanged($event)"
          ></p-inputSwitch>
        </div>
      </div>
    </div>

    <div
      class="estado-status-banner"
      *ngIf="isConnected"
      [class.estado-status-banner--active]="botEnabled"
      [class.estado-status-banner--inactive]="!botEnabled"
    >
      <div class="estado-status-banner__left">
        <div
          class="estado-status-dot"
          [class.estado-status-dot--active]="botEnabled"
          [class.estado-status-dot--inactive]="!botEnabled"
        >
          <i [class]="botEnabled ? 'pi pi-check-circle' : 'pi pi-times-circle'"></i>
        </div>
        <div>
          <span class="estado-status-title">
            {{ botEnabled ? 'Canal conectado y activo' : 'Canal conectado, respuestas pausadas' }}
          </span>
          <span class="estado-status-sub">{{ pageSubscription[0]?.page_name }}</span>
        </div>
      </div>
      <div class="estado-status-banner__actions">
        <button
          pButton
          pRipple
          type="button"
          class="p-button-outlined p-button-danger p-button-sm"
          icon="pi pi-times"
          label="Desconectar"
          [loading]="loading"
          (click)="showDeleteDialog(true)"
        ></button>
      </div>
    </div>

    <div class="attention-schedule-wrapper" *ngIf="isConnected && attentionScheduleConfig">
      <globot-attention-schedule-config
        [config]="attentionScheduleConfig"
        [saving]="savingAttentionSchedule"
        (save)="saveAttentionSchedule($event)"
      ></globot-attention-schedule-config>
    </div>

    <!-- GLOB-1868 AC1: Guided empty state — no Facebook page linked yet -->
    <div class="estado-connect-layout" *ngIf="!isConnected" data-testid="messenger-empty-state">
      <div class="estado-hero-card">
        <div class="estado-hero-banner"></div>
        <div class="estado-hero-body">
          <div>
            <h2 class="estado-hero-title">Conecta Messenger a tu asistente virtual</h2>
            <p class="estado-hero-sub">
              Vincula tu página de Facebook para que tu asistente virtual pueda responder los
              mensajes de Messenger automáticamente.
            </p>
          </div>
          <ol class="estado-steps">
            <li class="estado-step">
              <div class="estado-step__dot">1</div>
              <div class="estado-step__text">
                <span class="estado-step__title">Ten acceso como administrador</span>
                <span class="estado-step__desc"
                  >Si no administras la página, pide a quien la administre que complete la
                  conexión.</span
                >
              </div>
            </li>
            <li class="estado-step">
              <div class="estado-step__dot">2</div>
              <div class="estado-step__text">
                <span class="estado-step__title">Conecta tu página de Facebook</span>
                <span class="estado-step__desc"
                  >Haz clic en el botón y autoriza el acceso a tu página.</span
                >
              </div>
            </li>
            <li class="estado-step">
              <div class="estado-step__dot">3</div>
              <div class="estado-step__text">
                <span class="estado-step__title">¡Listo!</span>
                <span class="estado-step__desc"
                  >Tu asistente virtual quedará activo en Messenger. Podrás pausarlo cuando
                  quieras.</span
                >
              </div>
            </li>
          </ol>
          <div class="estado-btn-stack">
            <globot-button
              text="Conectar con Facebook"
              styleClass="facebook"
              icon="pi pi-facebook"
              iconPosition="left"
              width="w-100"
              [loading]="loading"
              (clickEvent)="linkFacebookAccount()"
            ></globot-button>
          </div>
        </div>
      </div>

      <div class="estado-features">
        <span class="estado-features__label">Una vez conectado podrás</span>
        <div class="estado-feature-card" *ngFor="let item of benefitItems">
          <div class="estado-feature-card__icon"><i [class]="item.icon"></i></div>
          <div class="estado-feature-card__text">
            <span class="estado-feature-card__title">{{ item.title }}</span>
            <span class="estado-feature-card__desc">{{ item.subtitle }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="deleteDialogVisible" [modal]="true" [closable]="false">
  <div class="content-dialog-delete">
    <h1>Desconectar de Facebook</h1>
    <br />
    <div class="description-content">
      <i class="pi pi-exclamation-triangle" style="color: #eab308"></i>
      <div class="description">
        <p>
          ¿Deseas desconectar tu asistente de este canal? Tus datos se <br />perderán y tendrás que
          realizar todo el proceso nuevamente.
        </p>
        <p>
          <b
            >¡Atención! Si tienes una cuenta de Instagram vinculada a esta <br />
            página de Facebook, también se desconectará.</b
          >
        </p>
      </div>
    </div>
    <br />
    <div style="display: flex; flex-direction: row; justify-content: flex-end">
      <button
        pButton
        pRipple
        type="button"
        label="Cancelar"
        class="p-button-text"
        (click)="closeDialogDelete(false)"
      ></button>
      <button
        pButton
        type="button"
        label="Si, desconectar"
        (click)="deleteAccountSubscription()"
      ></button>
    </div>
  </div>
</p-dialog>
